import React, { useContext, useState } from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Input, Form } from '../components';
import Header from '../components/Header';
import { CREDENTIALS, login } from '../resources/auth';

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 2.5em 0 0 0;
  width: 100%;
`;

const LoginByCredentials = () => {
  const history = useHistory();
  const [ uid, setUid ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ error, setError ] = useState('');
  const { t } = useTranslation();

  const handleLogin = async () => {
    setError('');
    login(uid, password, CREDENTIALS)
      .then(() => {
        history.push('/parking-locations');
      })
      .catch(() => setError('error.loginFailed'));
  };

  return (<>
    <Header>{t('welcomeMessage')}</Header>
    <Form layout="vertical" onFinish={handleLogin} style={{ padding: '1rem' }}>
      <Form.Item name="uid" label={t('identifier')}>
        <Input type="text" value={uid} onChange={e => setUid(e.target.value)}/>
      </Form.Item>
      <Form.Item name="password" label={t('password')}>
        <Input type="password" value={password} onChange={e => setPassword(e.target.value)}/>
      </Form.Item>
      {error && <Alert type="error" size="large" message={t(error)}/>}
      <StyledButtonContainer>
        <Button className="login-button" type="primary" size="large" htmlType="submit">{t('login')}</Button>
      </StyledButtonContainer>
    </Form>
  </>);
};

export default LoginByCredentials;
